/* eslint-disable no-undef */
import { useEffect, useRef } from 'react';

export const useInterval = (
  callback: (id: NodeJS.Timeout) => any,
  delay: number
) => {
  const savedCallback = useRef<any>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick(id: NodeJS.Timeout) {
      if (savedCallback?.current) {
        savedCallback?.current(id);
      }
    }
    if (delay !== null) {
      const id = setInterval(() => {
        tick(id);
      }, delay);
      return () => clearInterval(id);
    }

    return () => {};
  }, [delay]);
};
